// Libs
import React from 'react';
// Components
import DataFieldSwitcher from 'components/DataFieldManager/Switcher';
import { StandardField } from 'components/DataFieldManager/types';
// Cells
const CellRenderer = ({
	rowIndex,
	rowData,
	field,
	selected,
	fieldActionTypes,
	profile,
	setState,
	Container,
	stateTable,
	readOnly,
}) => {
	return (
		<DataFieldSwitcher
			rowIndex={rowIndex}
			rowData={rowData}
			field={new StandardField({ field, rowData })}
			selected={selected}
			fieldActionTypes={fieldActionTypes}
			profile={profile}
			setState={setState}
			Container={Container}
			stateTable={stateTable}
			readOnly={readOnly}
		/>
	);
};

export default CellRenderer;
